import React from 'react';
import {makeStyles} from '@material-ui/core';
import SearchResultTourListItem from './SearchResultTourListItem';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    layout: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }
}));

export default function SearchResultTourList(props) {
    const { className, tours } = props;
    const classes = useStyles();

    return (
        <div className={clsx(classes.layout, className)}>
            {tours.map(tour =>
                <SearchResultTourListItem key={tour.id} tour={tour}/>
            )}
        </div>
    );
}
